export default "__VITE_ASSET__CAXsRUac__"